module.exports = __webpack_public_path__ + "img/home_bg1_d.505a8002.png";